import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';
import { cn } from '@/shadcn-ui/utils';

export default function ArrowWithTailRight({
  className,
  fillPrimary = colors.neutral100,
  hoverFillPrimary,
}: SvgIconCommonProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 24"
      fill="none"
      className={cn('group h-[24px] w-[25px]', className)}
    >
      <path
        d="M22.5 12C22.5 11.6899 22.3624 11.3798 22.119 11.1628L15.1667 4.36176C14.8915 4.10336 14.6058 4 14.3201 4C13.6534 4 13.1772 4.45478 13.1772 5.07494C13.1772 5.39535 13.3042 5.67442 13.5159 5.88114L15.8862 8.22739L19.0079 11.0181L16.5423 10.8734H3.6746C2.98677 10.8734 2.5 11.3282 2.5 12C2.5 12.6615 2.98677 13.1266 3.6746 13.1266H16.5423L19.0185 12.9819L15.8862 15.7726L13.5159 18.1189C13.3042 18.3152 13.1772 18.5943 13.1772 18.9147C13.1772 19.5349 13.6534 20 14.3201 20C14.6058 20 14.8915 19.8863 15.1455 19.6486L22.119 12.8372C22.3624 12.6098 22.5 12.3101 22.5 12Z"
        fill={fillPrimary}
        className={hoverFillPrimary}
      />
    </svg>
  );
}
